import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { InfoWidget } from 'components';

import { priceTypes } from 'src/constants/enums';

import Product from '../Product';
import CategoryProductsWrapper from './components/CategoryProductsWrapper';

import style from './ProductsTable.module.scss';
import shared from 'styles/Shared.module.scss';

const COLLECTION_PRODUCTS_MESSAGE =
  'Lista produktów, które są dodane do Twojej oferty ponieważ zostały przez Ciebie wycenione w przeszłości lub ręcznie dodane.';
const NOT_COLLECTION_PRODUCTS_MESSAGE =
  'Lista produktów, o których wycenę poprosił klient, ale nie zostały przez Ciebie dodane do Twojej oferty ani wycenione w przeszłości.';

const ProductsTable = ({ inPublicPage, productsType }) => {
  const categories = useSelector((state) => state.supplierForm.categories);
  const priceType = useSelector((state) => state.supplierForm.form.price_type);

  const getProducts = useCallback((products = []) => {
    const arr = [];

    products.forEach((item) => {
      if (
        (productsType === 'in_collection' && item?.in_collection) ||
        (productsType === 'not_in_collection' && !item?.in_collection)
      ) {
        arr.push(
          <Product
            productData={item}
            key={String(item.id + item.name)}
          />
        );
      }
    });

    return arr;
  }, []);

  const categoriesElements = useMemo(() => {
    const arr = [];

    categories.forEach((cat) => {
      const products = getProducts(cat?.items);

      if (products.length) {
        arr.push(
          <CategoryProductsWrapper
            name={cat.name}
            key={cat.name + productsType}
          >
            {products}
          </CategoryProductsWrapper>
        );
      }
    });

    return arr;
  }, [categories]);

  const headerClasses = classNames(shared.tableHeader, style.header, {
    [style.headerNetto]: priceType.value === priceTypes.netto,
    [style.publicSticky]: inPublicPage
  });

  if (categoriesElements.length === 0) {
    return null;
  }

  return (
    <section className={classNames(shared.tableWrapper, style.container)}>
      <h2 className={classNames(style.title, { [style.notCollection]: productsType === 'not_in_collection' })}>
        {productsType === 'in_collection' ? 'Produkty z Twojej oferty' : 'Produkty, których nie masz w ofercie'}
        <InfoWidget place={'right'}>
          <p>{productsType === 'in_collection' ? COLLECTION_PRODUCTS_MESSAGE : NOT_COLLECTION_PRODUCTS_MESSAGE}</p>
        </InfoWidget>
      </h2>
      <div className={headerClasses}>
        <p>Nazwa</p>
        <p>Cena {priceType.label}</p>
        {priceType.value === priceTypes.netto && <p>Stawka VAT</p>}
        <p className={style.value}>Ilość</p>
        <p className={style.value}>Wartość</p>
        <p>Dostępność</p>
      </div>
      {categoriesElements}
    </section>
  );
};

export default ProductsTable;
